import(/* webpackMode: "eager" */ "/home/runner/work/next-embed-player/next-embed-player/src/app/global-error.jsx");
